module.exports = __webpack_public_path__ + "img/cuff_width.0d9f790f.png";